import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router/router.js';
import LangStore from './store/lang-store.js';
import VueAgile from 'vue-agile'
import "@fortawesome/fontawesome-free/css/all.min.css";

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueAgile)
Vue.config.productionTip = false

new Vue({
	store: LangStore,
	// Get the texts when component is created
	created: function () {
		fetch("/lang.json")
			.then(r => r.json())
			.then(json => {
				this.$store.commit('setTexts', json);
				console.log('Texts are set');
			});
	},
	router,
	render: h => h(App),
}).$mount('#app')
